module.exports = __webpack_public_path__ + "static/media/fly0180.4b26a54c.webp";